module.exports = __webpack_public_path__ + "static/media/pushpin2.24599cb5.png";